module.exports = __webpack_public_path__ + "c9c2c9b834b3a36fcd94341665d342cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/guess.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/guess.jpg
// module chunks = 40